// API Base URL Configuration
// Updated: 2025-12-04 - Force rebuild
// 
// Environments:
// 1. Local Development: Uses localhost:3001 (no env var needed)
// 2. Staging (Railway): Set REACT_APP_API_URL to staging backend URL
// 3. Production (Railway): Set REACT_APP_API_URL to production backend URL
//
// In Railway, just set REACT_APP_API_URL differently for staging vs production projects

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Log configuration for debugging
console.log('🔧 Environment:', process.env.NODE_ENV);
console.log('🔧 API URL:', API_BASE_URL);

// Warn if running production build without API URL
if (process.env.NODE_ENV === 'production' && API_BASE_URL === 'http://localhost:3001') {
  console.warn('⚠️  WARNING: Using localhost in production build!');
  console.warn('   Set REACT_APP_API_URL environment variable in Railway.');
}

export default API_BASE_URL;
